const getNewpayWallet = state => state.payment.newpay?.wallet;

export default getNewpayWallet;
